module.exports = __webpack_public_path__ + "static/media/management.dca8a64d.png";